/*
 * Onboarding 002 — the remaining bespoke screens: D6, D9, D10–D15, username and the
 * scratch card.
 *
 * Split from quiz-002-custom.js only to keep either file readable. Loaded after it.
 */
window.ReformlyQuiz = window.ReformlyQuiz || {};

(function (NS) {
  'use strict';

  var U = NS.ui, C = NS.calc, el = U.el, svg = U.svg, S = function () { return NS.store.state; };
  var statCard = NS.pieces.statCard;
  NS.customExtra = {};

  /* ─── Derivations (plan §0: level from W03, pace from A6) ────────────────── */

  var MOVEMENT = { mostly_seated: 'Mostly seated', moderately_active: 'Moderately active', on_feet_all_day: 'On your feet' };
  var LEVEL = { classes_taken: 'Intermediate', a_little_online: 'Beginner', first_time: 'Beginner' };
  var PACE = { five_to_seven: 'Five a week', three_to_five: 'Four a week', few_times_a_month: 'Three a week', not_much: 'Three a week' };
  var SESSIONS = { five_to_seven: '5', three_to_five: '4', few_times_a_month: '3', not_much: '3' };
  var BLURB = {
    underweight: ['A gentle starting point', 'A little under the healthy range. Your plan builds strength before anything else.'],
    normal: ['A strong place to start', 'Right in the healthy range. Your plan works on shape and consistency from here.'],
    overweight: ['A good place to start', 'Just above the healthy range, which is where most Reformly members begin. Your plan works from here.'],
    obese: ['A good place to start', 'Above the healthy range. Your plan starts gently and builds, with recovery days built in.'],
  };

  function titleCase(v) {
    return v ? String(v).replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '—';
  }

  /* ─── D6 Profile ─────────────────────────────────────────────────────────── */

  var ARROW_DOWN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 5v14M5 12l7 7 7-7" stroke="#222222" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function infoIcon(colour) {
    return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="' + colour +
      '" stroke-width="2"/><path d="M12 8v4M12 16h.01" stroke="' + colour + '" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  /* ─── Referral landing ───────────────────────────────────────────────────
   *
   * Port of reformly_web components/onboarding/ReferralLanding.tsx — step 0 of that
   * wizard. Personalised from the URL: ?ref= or ?referralCode= is resolved to a
   * username, and the screen greets the visitor by their friend's name.
   *
   * DIFFERS FROM THE TSX IN ONE WAY, DELIBERATELY. There, a missing or invalid code
   * renders an error and the quiz is unreachable — correct for a dedicated referral
   * URL. onboarding-008 is a general funnel, so a dead end would silently bin every
   * visitor who arrives without a code. Here the step is only added to STEPS when a
   * code is present (see quiz-002-data.js), and if the lookup then fails we advance
   * into the quiz instead of blocking.
   *
   * No `part`/`label` on the step, so the progress bar stays hidden — the TSX has no
   * progress on this screen either.
   */
  NS.customExtra.referralLanding = function (step, ctx) {
    var host = el('div.o2-ref');

    var code = NS.referralCode && NS.referralCode();
    /* Set by fill() once the lookup lands. Held in the closure because view() no
       longer takes the name — and a bare `name` inside view() would silently
       resolve to window.name in a browser rather than throwing. */
    var referrerName = null;

    /* Which namespace the code came from. ?referralCode= is refer-a-friend,
       ?ref= is affiliate, and getReferrerByCode resolves both — so without this
       the two funnels are indistinguishable in reports, which is the same reason
       track() stamps `funnel` on everything. */
    function codeSource() {
      try {
        var q = new URLSearchParams(location.search);
        if (q.get('referralCode')) return 'friend';
        if (q.get('ref')) return 'affiliate';
      } catch (e) { }
      return null;
    }

    function advance() {
      /* Nothing to greet them with — go straight into the quiz. ctx.next() rather
         than rendering an error, which is the whole point of this port's divergence.

         Deferred a tick: on the synchronous path below this runs INSIDE render(),
         and ctx.next() calls go() -> render() again, re-entering a function that is
         midway through replacing the stage. The async path is already off-stack; the
         timeout makes both behave the same way. */
      setTimeout(function () { ctx.next(); }, 0);
    }

    if (!code) { advance(); return host; }

    /* Fired before the lookup, so the funnel has a denominator: landings that
       RESOLVED over landings ATTEMPTED. Counting only the successes would hide a
       broken proxy or a batch of dead codes entirely. */
    NS.track('quiz002_referral_landing_attempted', { code_source: codeSource() });

    /* Paint the whole screen NOW, with the name-bearing text as placeholders.
       The TSX shows a bare spinner for the entire 700-1600ms round trip, but
       only the chip, heading and body actually need the API — the wordmark, the
       hero and the CTA never did. Rendering them immediately makes the screen
       arrive at once, and because the skeleton is the final layout, filling the
       text in shifts nothing. */
    host.appendChild(view(null));

    var startedAt = Date.now();
    /* Consume the in-flight request from quiz-002-data.js rather than firing a
       second one. By the time this screen renders it has usually been running for
       a few hundred ms already, so lookup_ms here is the REMAINING wait, which is
       the number that matters — it is what the visitor actually sees. */
    var pending = NS.referrerPromise || NS.api.getReferrer(code);
    pending.then(function (r) {
      var ms = Date.now() - startedAt;
      if (!r || !r.username) {
        /* The visitor sees no error — they just land in the quiz. That silence is
           deliberate, and it is exactly why this event has to exist: without it a
           dead code and a healthy one look identical in reports. */
        NS.track('quiz002_referral_landing_failed', { code_source: codeSource(), lookup_ms: ms });
        advance();
        return;
      }
      fill(r.username);
      NS.track('quiz002_referral_landing_shown', {
        code_source: codeSource(),
        lookup_ms: ms,
        /* The referrer's username, not the raw code: the code is a credential of
           sorts and the username is what the screen already displays. */
        referrer_username: r.username,
      });
      /* Rides on every later event in the funnel, so a signup can be attributed
         back to the referral landing without re-joining on session id. */
      try {
        if (window.posthog && window.posthog.register) {
          window.posthog.register({ quiz_referrer_username: r.username, quiz_code_source: codeSource() });
        }
      } catch (e) { }
    });

    function chip() {
      return el('div.o2-ref-chip', null, [
        el('span.o2-ref-avatar', {
          html: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none">' +
            '<path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="white"/></svg>',
        }),
        el('span.o2-ref-chip-text.is-skeleton', { 'data-ref-chip': true }),
      ]);
    }

    /* Swaps the placeholders for real copy. Text only — no nodes are added or
       removed, so nothing reflows and the hero never jumps. */
    function fill(name) {
      referrerName = name;
      var c = host.querySelector('[data-ref-chip]');
      if (c) { c.textContent = name + ' invited you'; c.classList.remove('is-skeleton'); }

      var h = host.querySelector('[data-ref-title]');
      if (h) {
        h.textContent = '';
        /* textContent for the name — it is user-supplied and must never reach
           innerHTML; only the fixed accent word is markup. */
        h.appendChild(document.createTextNode(name + ' gave you 7 days of Reformly+, '));
        h.appendChild(el('span.o2-ref-accent', { text: 'free' }));
        h.classList.remove('is-skeleton');
      }

      var b = host.querySelector('[data-ref-body]');
      if (b) {
        b.textContent =
          'Your friend ' + name + ' thinks you\u2019ll love working out from home. ' +
          'Take the 3-minute quiz and we\u2019ll build your plan. Your first 7 days are on us.';
        b.classList.remove('is-skeleton');
      }
    }

    function view() {
      var wrap = el('div.o2-ref-wrap');

      /* Everything here renders immediately. The three name-bearing nodes carry
         .is-skeleton until fill() runs; the rest is final on first paint. */
      wrap.appendChild(el('p.o2-ref-brand', {
        html: '<span class="o2-ref-brand-name">reformly</span><span class="o2-ref-brand-plus">+</span>',
      }));

      wrap.appendChild(el('div.o2-ref-head', null, [
        chip(),
        el('h1.o2-ref-title.is-skeleton', { 'data-ref-title': true }),
      ]));

      wrap.appendChild(el('p.o2-ref-body.is-skeleton', { 'data-ref-body': true }));

      /* Two <img>, not one responsive srcset: the crops differ (1.49 landscape on
         mobile, 0.81 portrait on desktop), so this is art direction, not resolution
         switching. CSS shows exactly one. */
      wrap.appendChild(el('div.o2-ref-hero', null, [
        el('img.o2-ref-hero-m', { src: NS.asset('referral_hero_mobile'), alt: 'Reformly app', loading: 'eager' }),
        el('img.o2-ref-hero-d', { src: NS.asset('referral_hero_desktop'), alt: 'Reformly app', loading: 'eager' }),
      ]));

      wrap.appendChild(el('div.o2-ref-cta', null,
        el('button.o2-ref-btn', {
          type: 'button',
          text: 'TAKE THE QUIZ',
          onclick: function () {
            NS.track('quiz002_referral_cta_click', {
              code_source: codeSource(),
              referrer_username: referrerName,
              /* True when they tapped through before the name arrived — the
                 skeleton makes that possible, and it is worth being able to see. */
              resolved: !!referrerName,
            });
            ctx.next();
          },
        })));

      return wrap;
    }

    return host;
  };

  NS.customExtra.profile = function (step, ctx) {
    var bmi = C.bmi() || 22;
    var cat = C.bmiCategory(bmi);
    var pct = C.bmiProgress(bmi) * 100;
    var blurb = BLURB[cat];
    var healthy = cat === 'normal';

    /* The BMI card keeps the 001 funnel's treatment — white card, spectrum bar, tinted
       note — rather than the cream/ink palette. The colour is semantic: it encodes where
       the healthy range sits, so flattening it would remove information, not restyle it. */
    var pill = el('div.o2-bmi-pill', { text: 'You — 15.0' });
    var arrow = el('div.o2-bmi-arrow', null, svg(ARROW_DOWN));
    var dot = el('div.o2-bmi-dot', null, el('span'));
    var bar = el('div.o2-bmi', null, [pill, arrow, el('div.o2-bmi-track'), dot]);

    /*
     * Markers slide in from the left edge and the reading counts up from 15.0, both over 1s
     * after a 200ms beat. The movement is what makes the number read as measured rather
     * than decorative. CSS holds the start state; setting the final left on a later frame
     * is what makes the browser animate rather than paint it in place.
     */
    var pillLeft = Math.min(Math.max(pct, 5), 85);
    var markLeft = Math.min(Math.max(pct, 3), 97);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pill.style.left = pillLeft + '%';
        arrow.style.left = markLeft + '%';
        dot.style.left = markLeft + '%';
      });
    });

    var t0 = null, FROM = 15, DUR = 1000, DELAY = 200;
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function tick(now) {
      if (t0 === null) t0 = now;
      var t = Math.min(Math.max((now - t0 - DELAY) / DUR, 0), 1);
      pill.textContent = 'You — ' + (FROM + (bmi - FROM) * ease(t)).toFixed(1);
      if (t < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    var labels = el('div.o2-bmi-labels');
    [['underweight', 'Underweight'], ['normal', 'Normal'], ['overweight', 'Overweight'], ['obese', 'Obese']]
      .forEach(function (p) {
        labels.appendChild(el('span' + (p[0] === cat ? '.is-on' : ''), { text: p[1] }));
      });

    var bmiCard = el('div.o2-bmicard', null, [
      el('div.o2-bmi-head', null, [
        el('span.o2-bmi-title', { text: 'Your BMI' }),
        el('span.o2-bmi-read', { text: titleCase(cat) + ' — ' + bmi.toFixed(1) }),
      ]),
      bar,
      labels,
    ]);

    // Green when in range, amber when not — same signal the spectrum bar gives.
    var blurbCard = el('div.o2-blurb' + (healthy ? '.is-healthy' : ''), null, [
      el('div.o2-blurb-head', null, [
        svg(infoIcon(healthy ? '#4CAF50' : '#FFA726')),
        el('span.o2-blurb-title', { text: blurb[0] }),
      ]),
      el('p.o2-blurb-body', { text: blurb[1] }),
    ]);

    var rows = [
      ['shape', titleCase(S().aboutYou.bodyType), 'Body shape'],
      ['clock', MOVEMENT[S().lifestyle.typicalDay] || '—', 'Daily movement'],
      ['goal', LEVEL[S().aboutYou.pilatesExperience] || 'Beginner', 'Pilates level'],
      ['clock', PACE[S().lifestyle.workoutFrequency] || 'Four a week', 'Best pace'],
    ];
    var stats = el('div.o2-profile-stats');
    rows.forEach(function (r) {
      stats.appendChild(el('div.o2-profile-row', null, [
        el('span.o2-profile-icon', null, el('img', { src: NS.asset(r[0]), alt: '' })),
        el('span.o2-profile-text', null, [
          el('span.o2-profile-val', { text: r[1] }),
          el('span.o2-profile-lbl', { text: r[2] }),
        ]),
      ]));
    });

    var figure = S().aboutYou.dreamBodyShape
      ? (function () {
        // Painted at 75% of the card, capped at 280px.
        var u = NS.asset('dream_' + String(S().aboutYou.dreamBodyShape).toLowerCase());
        return el('div.o2-profile-fig', null, el('img', {
          src: NS.sized(u, 300),
          srcset: NS.sized(u, 300) + ' 300w, ' + NS.sized(u, 600) + ' 600w',
          sizes: '280px', alt: '', decoding: 'async',
        }));
      })()
      : null;

    return U.screen({
      title: 'Here is your Reformly profile',
      content: [bmiCard, blurbCard, el('div.o2-profile-wrap', null, [stats, figure])],
      footer: U.primaryButton('Continue', ctx.next, { radius: 10 }),
    });
  };

  /* ─── Chart, shared by D9 and D14 ────────────────────────────────────────── */

  /**
   * Ported from the 001 funnel's chart: same control points, same smoothing, recoloured to
   * ink on cream. Drawn at native size per breakpoint (335×160 mobile, 620×300 web) rather
   * than one small drawing stretched — upscaling magnified every stroke and label, which is
   * what made the line look soft.
   *
   * The line is revealed with stroke-dashoffset rather than an animated clip: a clip forces
   * the browser to rasterise the subtree for the duration and it often keeps that raster,
   * leaving the stroke permanently blurry.
   */
  function weightChart(o) {
    var wide = window.matchMedia('(min-width: 768px)').matches;
    var W = wide ? 620 : 335, H = wide ? 300 : 160;
    var padL = wide ? 28 : 16, padR = padL, padT = wide ? 56 : 40, padB = wide ? 40 : 28;
    var cW = W - padL - padR, cH = H - padT - padB;
    var fs = function (m, w) { return wide ? w : m; };

    var spots = [
      [0, 2.8], [0.19, 2.8], [0.38, 2.6], [0.55, 2.23], [0.77, 1.8], [0.95, 1.7],
      [1.15, 1.76], [1.36, 1.76], [1.54, 1.6], [1.74, 1.26], [1.92, 0.92],
      [2.12, 0.6], [2.31, 0.42], [2.51, 0.33], [2.7, 0.3],
    ];
    /*
     * Doubled up before drawing: a midpoint is inserted between every pair, sampled from the
     * Catmull-Rom spline the curve already follows, so the shape is unchanged but each
     * bezier segment spans half the distance. Long segments are what show as faceting once
     * the drawing is scaled up to fill a wide column.
     *
     * Catmull-Rom at t=0.5 reduces to (-p0 + 9p1 + 9p2 - p3) / 16.
     */
    var dense = [];
    for (var si = 0; si < spots.length - 1; si++) {
      var a = spots[Math.max(si - 1, 0)], b = spots[si];
      var c = spots[si + 1], e = spots[Math.min(si + 2, spots.length - 1)];
      dense.push(b);
      dense.push([
        (-a[0] + 9 * b[0] + 9 * c[0] - e[0]) / 16,
        (-a[1] + 9 * b[1] + 9 * c[1] - e[1]) / 16,
      ]);
    }
    dense.push(spots[spots.length - 1]);
    spots = dense;

    var sx = function (x) { return padL + (x / 2.7) * cW; };
    var sy = function (y) { return padT + cH - (y / 3) * cH; };
    var pts = spots.map(function (s) { return [sx(s[0]), sy(s[1])]; });

    var t = 0.1, d = 'M ' + pts[0][0].toFixed(2) + ' ' + pts[0][1].toFixed(2);
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[Math.max(i - 1, 0)], p1 = pts[i], p2 = pts[i + 1], p3 = pts[Math.min(i + 2, pts.length - 1)];
      d += ' C ' + (p1[0] + (p2[0] - p0[0]) * t).toFixed(2) + ' ' + (p1[1] + (p2[1] - p0[1]) * t).toFixed(2) +
        ', ' + (p2[0] - (p3[0] - p1[0]) * t).toFixed(2) + ' ' + (p2[1] - (p3[1] - p1[1]) * t).toFixed(2) +
        ', ' + p2[0].toFixed(2) + ' ' + p2[1].toFixed(2);
    }
    var last = pts[pts.length - 1], baseY = padT + cH;
    var fill = d + ' L ' + last[0].toFixed(2) + ' ' + baseY + ' L ' + pts[0][0].toFixed(2) + ' ' + baseY + ' Z';
    var labels = o.labels || [];
    var xs = [sx(0), sx(0.9), sx(1.8), sx(2.7)];

    var markup =
      '<svg viewBox="0 0 ' + W + ' ' + (H + 28) + '" width="100%" style="overflow:visible">' +
      '<defs><linearGradient id="o2fill" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#222" stop-opacity=".18"/><stop offset="100%" stop-color="#222" stop-opacity=".02"/>' +
      '</linearGradient></defs>' +
      '<path d="' + fill + '" fill="url(#o2fill)" class="o2-chart-fill"/>' +
      '<line x1="' + padL + '" y1="' + baseY + '" x2="' + (W - padR) + '" y2="' + baseY + '" stroke="#E2DACB" stroke-dasharray="4 4"/>' +
      xs.map(function (x) { return '<line x1="' + x + '" y1="' + padT + '" x2="' + x + '" y2="' + baseY + '" stroke="#C9C0AE" stroke-dasharray="4 4"/>'; }).join('') +
      '<path d="' + d + '" fill="none" stroke="#222" stroke-width="' + fs(2.5, 3) + '" stroke-linecap="round" ' +
      'stroke-linejoin="round" shape-rendering="geometricPrecision" pathLength="1" class="o2-chart-line"/>' +
      '<circle cx="' + last[0] + '" cy="' + last[1] + '" r="' + fs(5, 6) + '" fill="#222"/>' +
      labels.map(function (l, i) {
        return '<text x="' + xs[i] + '" y="' + (baseY + 18) + '" text-anchor="middle" fill="#6F6659" ' +
          'style="font:500 ' + fs(11, 13) + 'px \'RSC Jakarta\',\'Plus Jakarta Sans\'">' + l + '</text>';
      }).join('') +
      '</svg>';

    return el('div.o2-chart', null, svg(markup));
  }

  /* ─── D9 Outlook ─────────────────────────────────────────────────────────── */

  NS.customExtra.outlook = function (step, ctx) {
    var m = S().metrics, p = S().plan;
    var unit = m.currentWeight.unit;
    // Goal date is the event date when there is one, otherwise a fixed 60-day horizon.
    var event = p.specialEventDate instanceof Date ? p.specialEventDate : null;
    var goalDate = event || new Date(Date.now() + 60 * 864e5);
    var name = event && p.specialEvent && p.specialEvent !== 'no_special_event'
      ? String(p.specialEvent).replace(/_/g, ' ') : null;
    var longFmt = function (d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }); };
    var shortFmt = function (d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); };
    // Four gridlines, four dates: start, two evenly spaced through the span, then the goal.
    var now = Date.now(), span = goalDate.getTime() - now;
    var chart = el('div.o2-chartcard', null, weightChart({
      labels: [
        shortFmt(new Date(now)),
        shortFmt(new Date(now + span / 3)),
        shortFmt(new Date(now + (span * 2) / 3)),
        shortFmt(goalDate),
      ],
    }));

    var pill = el('span.o2-goalpill', { text: (m.goalWeight.value || '—') + ' ' + unit + ' by ' + longFmt(goalDate) });
    var disclaimer = 'This chart is an illustration, not a promise. Results vary from person to person.';

    return el('div.o2-outlook', null, [
      el('div.o2-outlook-text', null, [
        el('h1.o2-title.big', { text: 'Your step-by-step wellness journey' }),
        el('p.o2-sub', { text: 'We will create a plan to help you reach your goal of' }),
        el('div.o2-goalpill-wrap', null, pill),
        name ? el('p.o2-intime', { html: 'Just in time for the <strong>' + name + '</strong>' }) : null,
        el('p.o2-footnote.only-web', { text: disclaimer }),
        // Mobile keeps the disclaimer with the button at the foot of the screen; web puts it
        // above the button, inside the left column — hence the two copies.
        el('div.o2-outlook-actions', null, [
          el('p.o2-footnote.only-mobile', { text: disclaimer }),
          U.primaryButton('Continue', ctx.next),
        ]),
      ]),
      el('div.o2-outlook-chart', null, chart),
    ]);
  };

  /* ─── Text-field screens ─────────────────────────────────────────────────── */

  /*
   * Rebuilding the screen on each keystroke — which is what calling rerender() from
   * oninput does — recreates the <input>, so focus and the caret are lost after every
   * character and typing is effectively impossible. Only the CTA's disabled state depends
   * on the value, so that is the only thing updated.
   */
  function textScreen(o, ctx) {
    var cta = U.primaryButton(o.cta || 'Continue', ctx.next, { disabled: !o.valid() });

    var input = el('input.o2-textin' + (o.underline ? '.underline' : ''), {
      type: o.underline ? 'text' : (o.type || 'text'),
      value: o.value(), placeholder: o.placeholder,
      oninput: function (e) {
        o.onChange(e.target.value);
        cta.disabled = !o.valid();
      },
    });

    var content = [o.underline ? el('div', null, [input, el('div.o2-rule')]) : input];
    if (o.below) content.push(o.below());

    return U.screen({ title: o.title, subtitle: o.subtitle, gap: 36, content: content, footer: cta });
  }

  NS.customExtra.email = function (step, ctx) {
    return textScreen({
      title: 'Where should we send your plan?',
      placeholder: 'Your email', type: 'email',
      value: function () { return S().auth.email; },
      onChange: function (v) { NS.store.set('auth', { email: v.trim() }); },
      valid: function () { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(S().auth.email); },
      below: function () {
        return NS.pieces.noticeCard('We will not spam you',
          el('p.o2-stat-body', { html: 'Your plan and your login, nothing else unless you ask for it. <a href="/policies/privacy-policy">Privacy Policy</a>.' }));
      },
    }, ctx);
  };

  NS.customExtra.displayName = function (step, ctx) {
    return textScreen({
      title: 'What is your name?',
      placeholder: 'Sophie', underline: true,
      value: function () { return S().plan.displayName; },
      onChange: function (v) { NS.store.set('plan', { displayName: v }); },
      valid: function () { return S().plan.displayName.trim().length > 0; },
    }, ctx);
  };

  /* ─── Username ───────────────────────────────────────────────────────────── */

  /*
   * Availability is deliberately loud: this is the only value the server can reject, and a
   * rejection would otherwise surface at the final submit, after fifty answered questions.
   *
   * Nothing here rebuilds the screen. The check is debounced and resolves while the user
   * may still be typing — a rebuild at that moment would drop focus mid-word.
   */
  NS.customExtra.username = function (step, ctx) {
    var timer = null, seq = 0, state = 'idle';
    // Answers for names already checked. Backspacing to a previous name, or returning to
    // this screen, then costs nothing.
    var cache = {};
    // Supersedes the in-flight request instead of letting it finish and be discarded.
    var inflight = null;

    var input = el('input.o2-textin.o2-uname', {
      type: 'text', value: S().profile.username, placeholder: 'sophie',
      autocapitalize: 'none', autocorrect: 'off', spellcheck: 'false',
    });

    var field = el('div.o2-unamebox', null, [el('span.o2-at', { text: '@' }), input]);
    var status = el('div.o2-notice.o2-status');
    var cta = U.primaryButton('Continue', ctx.next, { disabled: true });

    function formatOk(v) { return /^[a-z0-9._]{3,30}$/.test(v); }

    function paintStatus() {
      var v = S().profile.username;
      var ok = formatOk(v);
      var msg = null, icon = U.ICON.crossMuted;

      if (v && !ok) msg = '3–30 characters — letters, numbers, dots and underscores';
      else if (state === 'checking') msg = 'Checking…';
      else if (state === 'taken') msg = 'That one is taken — try another';
      else if (state === 'available') { msg = '@' + v + ' is yours'; icon = U.ICON.checkGreen; }

      field.className = 'o2-unamebox' + (state === 'available' ? ' ok' : (state === 'taken' || (v && !ok)) ? ' bad' : '');
      status.style.display = msg ? '' : 'none';
      status.innerHTML = '';
      if (msg) {
        status.appendChild(svg(icon));
        status.appendChild(el('span.o2-notice-title', { text: msg }));
      }
      cta.disabled = !ok || state === 'taken' || state === 'checking';
    }

    input.addEventListener('input', function (e) {
      var v = e.target.value.toLowerCase().trim();
      NS.store.set('profile', { username: v });
      state = 'idle';
      seq++;
      clearTimeout(timer);

      if (formatOk(v)) {
        if (v in cache) {
          state = cache[v] ? 'available' : 'taken';
          paintStatus();
          return;
        }
        state = 'checking';
        var mine = seq;
        if (inflight) inflight.abort();
        // 300ms rather than 500: long enough that a fast typist does not fire a request per
        // keystroke, short enough that the answer is not waiting on us.
        timer = setTimeout(function () {
          inflight = window.AbortController ? new AbortController() : null;
          NS.api.checkUsername(v, inflight && inflight.signal).then(function (r) {
            if (mine !== seq) return; // a newer keystroke won the race
            /*
             * Only an explicit `available: false` means taken. Treating every other reply as
             * taken made a proxy that answers 200 with something other than our JSON — an
             * ngrok interstitial, a Shopify error page — read as "that one is taken" for
             * every name typed, with no request ever reaching the server.
             */
            if (r && typeof r.available === 'boolean') cache[v] = r.available;
            state = r && r.available === false ? 'taken'
              : r && r.available === true ? 'available'
                : 'idle';
            if (state === 'idle') console.warn('[quiz002] username check: unexpected reply', r);
            paintStatus();
          }).catch(function (e) {
            // Never block on a network failure — the server revalidates at signup. An abort
            // is not a failure: a newer keystroke replaced this check.
            if (e && e.name === 'AbortError') return;
            if (mine === seq) { state = 'idle'; paintStatus(); }
          });
        }, 300);
      }
      paintStatus();
    });

    var bio = el('textarea.o2-textarea', {
      rows: 3, maxlength: 500, placeholder: 'Here for the 20-minute sessions and the recipes.',
    });
    bio.value = S().profile.bio;
    bio.addEventListener('input', function (e) { NS.store.set('profile', { bio: e.target.value }); });

    paintStatus();

    return U.screen({
      title: 'Pick a username',
      subtitle: 'This is how other members will see you in the community.',
      gap: 28,
      content: [
        field, status,
        el('div.o2-biowrap', null, [
          el('p.o2-stat-label', { html: 'Add a line about you <span>(optional)</span>' }),
          bio,
        ]),
      ],
      footer: cta,
    });
  };

  /* ─── D12 Opt in, D15 Country ────────────────────────────────────────────── */

  NS.customExtra.optIn = function (step, ctx) {
    // D12 is the same two-column interstitial as W02/W04 on web, so it renders through the
    // interstitial renderer rather than being its own layout.
    return NS.renderers.interstitial({
      title: 'Want tips, recipes and offers as well?',
      body: 'Short emails from our team, once or twice a week. You can stop them at any time.',
      // Reuses the recipes screen's artwork — same subject, and it saves a fetch since the
      // file is already cached by the time this screen is reached.
      img: { m: 'recipes_mobile', w: 'recipes_web', ar: '1200 / 898', arWeb: '1200 / 1068' },
      cta: 'Yes, send them',
      secondary: {
        label: 'No thanks',
        onClick: function () { NS.store.set('lifestyle', { marketingEmailsOptIn: false }); ctx.next(); },
      },
    }, {
      next: function () { NS.store.set('lifestyle', { marketingEmailsOptIn: true }); ctx.next(); },
    });
  };

  /*
   * Country comes from Liquid (localization.country), so there is nothing to detect and no
   * request to make — this screen only confirms it.
   *
   * "No, change my country" used to clear the value and advance, which skipped the question
   * entirely: there is no country picker further down the funnel to land on. It now switches
   * this screen into an entry state instead.
   */
  NS.customExtra.country = function (step, ctx) {
    var host = el('div.o2-numhost');
    var choosing = !S().auth.quizCountry;

    function why() {
      return NS.pieces.noticeCard('Why we ask',
        el('p.o2-stat-body', { text: 'So we can show you the right currency and the right delivery times for the board.' }));
    }

    function build() {
      var detected = S().auth.quizCountry;

      if (choosing) {
        var cta = U.primaryButton('Continue', ctx.next, { disabled: !detected });
        var countries = NS.COUNTRIES || [];
        var field;

        if (countries.length) {
          // A select, not free text: this value drives currency and delivery copy, so it has
          // to match a country the store actually sells to.
          field = el('select.o2-textin.o2-select', {
            onchange: function (e) {
              NS.store.set('auth', { quizCountry: e.target.value || null });
              cta.disabled = !e.target.value;
            },
          });
          field.appendChild(el('option', { value: '', text: 'Select your country' }));
          countries.forEach(function (name) {
            var o = el('option', { value: name, text: name });
            if (name === detected) o.selected = true;
            field.appendChild(o);
          });
        } else {
          // Markets returned nothing — better a typed answer than no way to continue.
          field = el('input.o2-textin', {
            type: 'text', value: detected || '', placeholder: 'United Kingdom',
            oninput: function (e) {
              var v = e.target.value.trim();
              NS.store.set('auth', { quizCountry: v || null });
              cta.disabled = !v;
            },
          });
        }

        return U.screen({
          title: 'Where are you based?',
          gap: 24,
          content: [field, why()],
          footer: cta,
        });
      }

      return U.screen({
        title: 'Are you in ' + detected + '?',
        gap: 24,
        content: why(),
        footer: [
          U.primaryButton('Yes, I am', ctx.next, { radius: 12 }),
          U.textButton('No, change my country', function () {
            choosing = true;
            rerenderLocal();
          }),
        ],
      });
    }

    function rerenderLocal() { host.innerHTML = ''; host.appendChild(build()); }
    rerenderLocal();
    return host;
  };

  /* ─── D10 Building plan — the single submit point ────────────────────────── */

  var BUILD = ['Matching sessions to your level', 'Setting your weekly pace', 'Choosing your recipes'];

  NS.customExtra.building = function (step, ctx) {
    var host = el('div.o2-build-host');
    var progress = 0, animationDone = false, apiDone = false, advanced = false;
    var failed = null, existing = false;

    function tryAdvance() {
      if (!animationDone || !apiDone || advanced) return;
      advanced = true;
      ctx.next();
    }

    // The request fires on mount, in parallel with the animation, and the screen advances
    // only when both have finished — so a slow network reads as a longer build rather than
    // a spinner, and a fast one still shows the animation.
    NS.track('quiz002_signup_started');
    NS.api.quizSignup(Object.assign(C.mapPayload(), { email: S().auth.email }))
      .then(function (data) {
        if (data && data.existingAccount) {
          NS.track('quiz002_signup_existing_account');
          existing = true; paint(); return;
        }
        if (data && data.user) {
          NS.store.set('auth', { userId: data.user.id, isVerified: true, onboardingCompleted: true });
          if (window.posthog && window.posthog.identify) window.posthog.identify(data.user.id);
        }
        NS.track('quiz002_signup_succeeded');
        NS.track('quiz002_completed');
        apiDone = true; tryAdvance();
      })
      .catch(function (e) {
        NS.track('quiz002_signup_failed', { reason: e && e.message });
        failed = (e && e.message) || 'Something went wrong';
        paint();
      });

    var t0 = Date.now(), total = 1200 * BUILD.length;
    var tick = setInterval(function () {
      progress = Math.min(Math.round(((Date.now() - t0) / total) * 100), 100);
      if (progress >= 100) {
        clearInterval(tick);
        // Hold once the ring fills so the third tick is actually seen — otherwise it lands
        // on the same frame as the advance and never appears checked.
        setTimeout(function () { animationDone = true; tryAdvance(); }, 700);
      }
      if (!failed && !existing) paint();
    }, 50);

    function paint() {
      host.innerHTML = '';

      if (existing) {
        host.appendChild(U.screen({
          title: 'That email is already registered', gap: 24,
          content: NS.pieces.noticeCard(S().auth.email,
            el('p.o2-stat-body', { text: 'An account already uses this address. Enter a different one to carry on — your answers are all still saved.' }),
            U.ICON.crossMuted),
          footer: U.primaryButton('Use a different email', function () { ctx.goTo('email'); }),
        }));
        return;
      }

      if (failed) {
        host.appendChild(U.screen({
          title: 'That did not save', subtitle: failed, gap: 24,
          content: el('p.o2-stat-body', { text: 'Your answers are still here — nothing is lost.' }),
          footer: U.primaryButton('Try again', function () { window.location.reload(); }),
        }));
        return;
      }

      var R = 55, CIRC = 2 * Math.PI * R;
      var ring = svg(
        '<svg width="120" height="120" viewBox="0 0 120 120">' +
        '<circle cx="60" cy="60" r="' + R + '" stroke="#E2DACB" stroke-width="6" fill="none"/>' +
        '<circle cx="60" cy="60" r="' + R + '" stroke="#222" stroke-width="6" fill="none" stroke-linecap="round" ' +
        'stroke-dasharray="' + CIRC + '" stroke-dashoffset="' + (CIRC * (1 - progress / 100)) + '" transform="rotate(-90 60 60)"/>' +
        '<text x="60" y="71" text-anchor="middle" fill="#222" style="font:600 32px \'RSC Jakarta\',\'Plus Jakarta Sans\'">' + progress + '%</text>' +
        '</svg>');

      var done = Math.min(Math.floor((progress / 100) * (BUILD.length + 0.35)), BUILD.length);
      var list = el('div.o2-buildlist');
      BUILD.forEach(function (label, i) {
        list.appendChild(el('div.o2-buildrow', null, [
          el('span.o2-buildmark', null, i < done ? svg(U.ICON.tickGreenSmall) : el('span.o2-builddot')),
          el('span' + (i < done ? '.done' : ''), { text: label }),
        ]));
      });

      var stars = el('div.o2-stars');
      for (var i = 0; i < 5; i++) stars.appendChild(svg(U.ICON.star));

      host.appendChild(el('main.o2-main', null, el('div.o2-col.o2-build', null, [
        ring,
        el('p.o2-buildtitle', { text: 'Building your Reformly plan' }),
        list,
        el('p.o2-buildsocial', { text: 'Over 50,000 women are already following a plan' }),
        el('div.o2-testimonial', null, [
          stars,
          el('p.o2-testi-head', { text: 'I finally stuck with something' }),
          el('p.o2-stat-body', { text: 'Twenty minutes before work, and I did not have to go anywhere to do it. Three months in and my clothes fit completely differently.' }),
          el('p.o2-testi-name', { text: 'Rachel' }),
        ]),
      ])));
    }

    paint();
    return host;
  };

  /* ─── D14 Plan ready ─────────────────────────────────────────────────────── */

  /* 18x18 on a 20 viewBox, ink at 1.4 — the D14 set, heavier than the muted W07 icons. */
  function statIcon(inner) {
    return '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="#222222" ' +
      'stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">' + inner + '</svg>';
  }
  var READY_ICONS = [
    statIcon('<path d="M10 4.5v5l3 2M3.5 10a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0"/>'),
    statIcon('<circle cx="10" cy="10" r="6.5"/><circle cx="10" cy="10" r="2.4"/>'),
    statIcon('<path d="M6 16.5V4.5h8l-1.6 3.2L14 11H6"/>'),
  ];

  NS.customExtra.planReady = function (step, ctx) {
    var name = (S().plan.displayName || '').trim();
    var sessions = SESSIONS[S().lifestyle.workoutFrequency] || '4';

    var stats = el('div.o2-readystats');
    [[sessions, 'Sessions a week'], ['20 min', 'Each session'], ['Day 7', 'First check-in']].forEach(function (r, i) {
      stats.appendChild(el('div.o2-readyrow', null, [
        el('span.o2-readyicon', null, svg(READY_ICONS[i])),
        el('span', null, [
          el('span.o2-readyval', { text: r[0] }),
          el('span.o2-readylabel', { text: r[1] }),
        ]),
      ]));
    });

    return U.screen({
      title: (name ? name + ', y' : 'Y') + 'our 60-Day Transformation is ready',
      gap: 28,
      content: [
        el('div.o2-chartcard', null, weightChart({ labels: ['Week 1', 'Week 2', 'Week 4', 'Week 8'] })),
        el('div.o2-readycard', null, [
          stats,
          // 150px wide on mobile, 210 on web.
          el('div.o2-readyfig', null, el('img', {
            src: NS.sized(NS.asset('coach_flex'), 250),
            srcset: NS.sized(NS.asset('coach_flex'), 250) + ' 250w, ' + NS.sized(NS.asset('coach_flex'), 450) + ' 450w',
            sizes: '(min-width: 768px) 210px, 150px',
            alt: '', decoding: 'async',
          })),
        ]),
      ],
      footer: [
        el('p.o2-footnote', { text: 'This chart is an illustration only.' }),
        U.primaryButton('Continue', ctx.next),
      ],
    });
  };

  /*
   * The scratch overlay is DRAWN, not loaded — same as the React version. Shipping it as a
   * .webp would mean a second file to keep in sync with the ticket geometry below, and the
   * whole thing is thirty lines of canvas.
   */
  var TICKET_PATH = 'M231.204 12.7188L231.204 239.578L212.126 265.016L231.204 290.453L231.204 356.125C231.204 363.149 225.51 368.844 218.486 368.844L12.7188 368.844C5.69438 368.844 0 363.149 0 356.125L0 290.453L19.0781 265.016L0 239.578L0 12.7188C0 5.6944 5.69436 0 12.7187 0L218.485 0C225.51 0 231.204 5.69439 231.204 12.7188Z';
  var DASH_PATH = 'M35.1 265.66C35.1 269.172 37.948 272.019 41.46 272.019L59.59 272.019C63.103 272.019 65.95 269.172 65.95 265.66C65.95 262.148 63.103 259.3 59.59 259.3L41.46 259.3C37.948 259.3 35.1 262.148 35.1 265.66Z M78.483 265.66C78.483 269.172 81.33 272.019 84.842 272.019L102.973 272.019C106.485 272.019 109.332 269.172 109.332 265.66C109.332 262.148 106.485 259.3 102.973 259.3L84.842 259.3C81.33 259.3 78.483 262.148 78.483 265.66Z M121.865 265.66C121.865 269.172 124.712 272.019 128.224 272.019L146.355 272.019C149.867 272.019 152.715 269.172 152.715 265.66C152.715 262.148 149.867 259.3 146.355 259.3L128.224 259.3C124.712 259.3 121.865 262.148 121.865 265.66Z M165.247 265.66C165.247 269.172 168.094 272.019 171.606 272.019L189.737 272.019C193.249 272.019 196.097 269.172 196.097 265.66C196.097 262.148 193.249 259.3 189.737 259.3L171.606 259.3C168.094 259.3 165.247 262.148 165.247 265.66Z';

  function scratchOverlay(width, height) {
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var c = canvas.getContext('2d');
    if (!c || !window.Path2D) return null;

    c.clip(new Path2D(TICKET_PATH));

    // Ink ramp: a touch lighter at the top so the ticket still reads as a surface.
    var g = c.createLinearGradient(0, 0, width, height);
    g.addColorStop(0, '#3A3A3A');
    g.addColorStop(1, '#222222');
    c.fillStyle = g;
    c.fillRect(0, 0, width, height);

    c.fillStyle = '#F5F0E8';
    c.fill(new Path2D(DASH_PATH));

    c.strokeStyle = 'rgba(245,240,232,0.5)';
    c.lineWidth = 8;
    c.lineCap = 'round';
    c.beginPath();
    c.moveTo(width * 0.2, height * 0.35);
    c.lineTo(width * 0.4, height * 0.55);
    c.lineTo(width * 0.3, height * 0.45);
    c.lineTo(width * 0.6, height * 0.65);
    c.lineTo(width * 0.5, height * 0.5);
    c.lineTo(width * 0.7, height * 0.6);
    c.stroke();

    return canvas.toDataURL('image/png');
  }

  /* ─── Scratch card ───────────────────────────────────────────────────────── */

  NS.customExtra.scratch = function (step, ctx) {
    var name = (S().plan.displayName || '').trim();
    var code = name
      ? name + '_' + new Date().toLocaleString('en-US', { month: 'short' }).toLowerCase() + String(new Date().getFullYear()).slice(-2)
      : 'REFORMLY';

    /*
     * The ticket is the SVG path, not a rounded box: it carries the two side notches and the
     * row of perforation pills, which a border-radius cannot express. Same path the overlay
     * is clipped to, so the scratch surface lines up with the ticket edge exactly.
     *
     * WHITE ticket under a BLACK overlay. Both were dark, so scratching removed dark from
     * dark and you could not see what you had uncovered.
     */
    var ticketArt = svg(
      '<svg class="o2-ticket-art" width="232" height="369" viewBox="0 0 232 369" fill="none">' +
      '<path d="' + TICKET_PATH + '" fill="#FFFFFF"/>' +
      // The perforation pills read as holes, so they take the page colour behind the card.
      '<path d="' + DASH_PATH + '" fill="#F5F0E8"/></svg>'
    );

    var CHECK = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="#00B67A" stroke-width="1.5"/><path d="M6.5 10.2L9 12.6L13.6 7.4" stroke="#00B67A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var canvasHost = el('div.o2-scratch-canvas');
    var hint = el('p.o2-ticket-hint', { text: 'Scratch it off!' });

    var ticket = el('div.o2-ticket', null, [
      ticketArt,
      el('div.o2-ticket-top', null, [
        // One headline at one size — the prize is a single phrase, so splitting it
        // across two type sizes made it read as two unrelated lines.
        // Comes from the section setting: each funnel promises its own offer's trial.
        el('span.o2-ticket-head', { text: (NS.config && NS.config.scratchPrize) || '1 month free' }),
        el('span.o2-ticket-sub', { html: (NS.config && NS.config.scratchSub) || 'With your Reformly<br>Pilates Board' }),
      ]),
      el('div.o2-ticket-code', null, [
        el('p.o2-ticket-codelabel', { text: 'Promo Code' }),
        el('div.o2-ticket-coderow', null, [svg(CHECK), el('span.o2-ticket-codeval', { text: code })]),
      ]),
      canvasHost,
      hint,
    ]);

    function dropHint() { if (hint.parentNode) hint.parentNode.removeChild(hint); }
    ticket.addEventListener('pointerdown', dropHint, { once: true });

    /*
     * Whatever happens, the screen moves on — revealing, or failing to build the canvas at
     * all, both end at the offer. This is the last step, so a scratch surface that never
     * initialises would otherwise be a dead end.
     */
    var advanced = false;
    function advance() {
      if (advanced) return;
      advanced = true;
      dropHint();
      setTimeout(ctx.finish, 1000);
    }
    function giveUp() { canvasHost.style.display = 'none'; advance(); }

    // Reuses reformly-scratchcard-lib.js, already in the theme for the other scratch pages,
    // rather than vendoring a second copy.
    requestAnimationFrame(function () {
      try {
        var lib = window.ScratchCardLib;
        if (!lib || !lib.ScratchCard) return giveUp();
        var overlay = scratchOverlay(232, 369);
        if (!overlay) return giveUp();

        // scratchType takes the library's enum, NOT the string 'line'. With a string it
        // still initialises and paints the overlay, but no stroke ever registers — the card
        // looks right and cannot be scratched.
        var sc = new lib.ScratchCard(canvasHost, {
          scratchType: lib.SCRATCH_TYPE.LINE,
          containerWidth: 232, containerHeight: 369,
          imageForwardSrc: overlay, htmlBackground: '<div></div>',
          clearZoneRadius: 25, percentToFinish: 10, enabledPercentUpdate: true,
          callback: advance,
        });
        sc.init().catch(giveUp);
      } catch (e) { giveUp(); }
    });

    return U.screen({
      title: 'Scratch to reveal your special discount',
      subtitle: 'We want you to start your journey with a nice surprise',
      gap: 32,
      content: el('div.o2-scratch-wrap', null, ticket),
    });
  };

})(window.ReformlyQuiz);
